/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSection } from '@fitinsur/components'

import { Row } from "components/Grid";

import { GeneralSection } from '../../general/index';
import { BrokerRemunerationSection } from '../index';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  brokerRemunerationGroup,
  setBrokerRemunerationGroup,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {

  return (
    <>
      <Row>
        <GeneralSection.components.Styled.Title>
          Other Fees
        </GeneralSection.components.Styled.Title>
      </Row>

      {brokerRemunerationGroup.map((questions, index) => (
        <FormSection
          key={index}
          sectionIndex={index}
          sectionName="BROKER_REMUNERATION"
          formikRef={formikRef}
          disableAll={disableAll}
          values={formikProps.values}
          errors={formikProps.errors}
          setFieldValue={formikProps.setFieldValue}
          setFieldError={formikProps.setFieldError}
          questionnaire={questions}
          idOperation={idOperation}
          idOperationParent={idOperationParent}
          idProduct={idProduct}
          extraButtons={() => {
            return GeneralSection.components.RenderSectionAddAndRemoveRowButtons({
              partySectionName: "BROKER_REMUNERATION",
              sectionState: brokerRemunerationGroup,
              setSectionState: setBrokerRemunerationGroup,
              index,
              questions,
              questionnaireAnswersToDelete,
              setQuestionnaireAnswersToDelete
            });
          }}
          onQuestionChange={(
            question,
            value,
            questionnaireUpdated,
            setQuestionnaireUpdated,
            setFieldValue
          ) =>
            BrokerRemunerationSection.events.handleQuestionChange({
              question,
              value,
              questionnaireUpdated,
              setQuestionnaireUpdated: (questionnaire) => setBrokerRemunerationGroup(brokerRemunerationGroup.map((v, i) => i === index ? questionnaire : v)),
              setFieldValue,
            })
          }
        />
      ))}
    </>
  )
}

const components = {
  RenderSection
}

export { components }